import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#a51e23',
      },
    },
  },
  icons: {
    iconfont: 'fa',
    values: {
      radioOn: 'far fa-dot-circle',
      radioOff: 'far fa-circle',
      checkboxOn: 'far fa-check-square',
      checkboxOff: 'far fa-square',
      clear: 'far fa-times-circle'
    },
  },
})
